<template>
  <v-container fluid>
    <v-data-table-server
      :headers="headers"
      :items="sapgs"
      :search="search"
      density="compact"
      :items-length="totalItems"
      :loading="loadingDatatables"
      @update:sortBy="toSort"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-text-field
            v-model="search"
            density="compact"
            :label="this.$t('search')"
            class="pl-2"
            :prepend-inner-icon="mdiMagnify"
            @update:modelValue="toSearchBack"
            variant="solo-filled"
            flat
            hide-details
            single-line
          ></v-text-field>
          <v-spacer></v-spacer>
          <v-btn
            variant="elevated"
            class="mb-2 text-white mr-3"
            :prepend-icon="mdiAccountPlus"
            color="#ffb300"
            @click="openDialog"
            dark
          >
            {{ $t("admin.new-sapg") }}
          </v-btn>
        </v-toolbar>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon class="me-2" size="small" @click="editItem(item)">
          {{ mdiPencil }}
        </v-icon>
        <v-icon size="small" @click="deleteItem(item)">
          {{ mdiDelete }}
        </v-icon>
      </template>

      <template v-slot:bottom>
        <pagination-dynamic :store="'sapgs'"></pagination-dynamic>
      </template>
    </v-data-table-server>
    <add-edit-sapg
      :modelDialog="sapgDialog"
      @close="sapgDialog = false"
    ></add-edit-sapg>
  </v-container>
</template>

<script>
import { mdiPencil, mdiDelete, mdiMagnify, mdiAccountPlus } from "@mdi/js";
import PaginationDynamic from "@/components/PaginationDynamic.vue";
import AddEditSapg from "./admin/AddEditSapg.vue";
import paginate from "@/mixins/paginations";
import { mapState } from "vuex";

export default {
  name: "SapgAdmin",
  components: { AddEditSapg, PaginationDynamic },
  mixins: [paginate],
  data() {
    return {
      mdiAccountPlus,
      mdiMagnify,
      mdiPencil,
      mdiDelete,
      dialog: false,
      dialogDelete: false,
      sapgDialog: false,
      itemsPerPage: 15,
      page: 1,
      headers: [
        { title: "Nom", key: "name" },
        { title: "Actions", key: "actions", sortable: false, align: "end" }
      ]
    };
  },
  computed: {
    ...mapState({
      sapgs: (state) => state.sapgs.items,
      loadingDatatables: (state) => state.loadingTables,
      totalItems: (state) => state.paginations.totalCount,
      editedId: (state) => state.sapgs.editedId
    }),
    pageCount() {
      return Math.ceil(this.sapgs.length / this.itemsPerPage);
    },
    search: {
      get() {
        return this.$store.state.paginations.search;
      },
      set(value) {
        this.$store.commit("paginations/setSearch", value);
      }
    }
  },
  methods: {
    toSort(item) {
      this.sortBy(item, "sapgs");
    },
    toSearchBack(value, time = 500) {
      this.searchBack(value, time, "sapgs");
    },
    openDialog() {
      this.$store.commit("sapgs/setEditedId", -1);
      this.$store.commit("sapgs/setEditedItem", Object.assign({}, {}));
      this.sapgDialog = true;
    },
    editItem(item) {
      this.$store.commit("sapgs/setEditedId", item.id);
      this.$store.commit("sapgs/setEditedItem", Object.assign({}, item));
      this.sapgDialog = true;
    },
    deleteItem(item) {
      if (confirm(this.$t("alert.delete.sapg"))) {
        this.$store
          .dispatch("sapgs/deleteItem", item.id)
          .then(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.success.sapg-delete"),
              color: "success"
            });
            this.toSearchBack(this.search, 500, "sapgs");
          })
          .catch(() => {
            this.$store.dispatch("showSnackbar", {
              message: this.$t("alert.error.sapg-delete"),
              color: "error"
            });
          });
      }
    }
  }
};
</script>
